export default __webpack_public_path__ + "static/media/rent.896b891c.jpg";